
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.356 5L2.718 2.682v4.636L7.356 5zm2.748.916a1.024 1.024 0 000-1.832L2.152.11a1.024 1.024 0 00-1.482.916v7.95c0 .76.801 1.256 1.482.916l7.952-3.975zM24.67 1.818A1.818 1.818 0 0022.852 0h-6.364a1.818 1.818 0 00-1.818 1.818v6.364c0 1.004.814 1.818 1.818 1.818h6.364a1.818 1.818 0 001.818-1.818V1.818zm-8.182 0h6.364v6.364h-6.364V1.818z","fill":"#D3C9FA"}}),_c('rect',{attrs:{"x":".67","y":"14","width":"10","height":"2","rx":"1","fill":"#D3C9FA"}}),_c('rect',{attrs:{"x":".67","y":"18","width":"10","height":"2","rx":"1","fill":"#D3C9FA"}}),_c('rect',{attrs:{"x":".67","y":"22","width":"10","height":"2","rx":"1","fill":"#D3C9FA"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M23.76 24H15.58a.909.909 0 01-.715-1.47l3.893-4.959v-1.783A.91.91 0 0118.991 14h1.358a.91.91 0 01.234 1.788v1.783l3.893 4.958A.909.909 0 0123.76 24zm-4.09-4.647l-2.221 2.829h4.442l-2.221-2.83z","fill":"#D3C9FA"}})])
          )
        }
      }
    